import { Config } from './config.model';

export const config: Partial<Config> = {
  api: {
    url: 'http://localhost:8076',
    terminalWebSocketUrl: 'ws://terminal.ras.oplog.cloud:6161/',
  },
  auth: {
    domain: 'https://oplog.kinde.com',
    client_id: '3ae471e315584df88787c43a5379a3f8',
    redirect_uri: 'http://localhost:3000/callback',
    logout_uri: 'http://localhost:3000/login',
    audience: 'https://maestro-api',
    scope: 'openid email profile offline',
    org_code: 'org_9a024f348a0c', // Default OPLOG organization for development
  },
};
